import { BaseService } from "./BaseService";

export const DescentralizacaoService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('descentralizacao/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos descentralizações:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`descentralizacao/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de descentralizações:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('descentralizacao/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir descentralizações:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('descentralizacao/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar descentralizações:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('descentralizacao/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar descentralizações:', error);
            return false;
        }
    }, 
}